import React from 'react'
import { OneXTwoLandingSample } from './types'
import { authCallbacks } from '@root/misc/authCallbacks'
import I18n from 'i18n-js'
import BetStatusShortCountdown from '@root/bet_utils/BetStatusShortCountdown'
import useDeadlineCountdown from '@root/bet_utils/use_deadline_countdown'
import { unwrapSec } from '../SquadBet/helper'

const NextBetTeaser: React.FC<{ sample: OneXTwoLandingSample }> = ({ sample }) => {
  const secondsLeft = useDeadlineCountdown(sample.deadline)

  return <div className="oneXtwo__nextBetTeaser__wrapper">
    <a className="oneXtwo__nextBetTeaser" onClick={() => authCallbacks.login()}>
      <div className="oneXtwo__nextBetTeaser__head">
        <div className="oneXtwo__nextBetTeaser__head__title">
          <span>{I18n.t('landing.sample_bet.title1')}</span>
          <strong>{I18n.t('landing.sample_bet.title2')}</strong>
        </div>
        <div>
          <BetStatusShortCountdown segments={unwrapSec(secondsLeft)} />
        </div>
      </div>
      <div className="oneXtwo__nextBetTeaser__body">
        <div className="oneXtwo__nextBetTeaser__teamHolder oneXtwo__nextBetTeaser__teamHolder--home">
          <div><img src={sample.home_flag} /></div>
          <strong><span>{I18n.t('onextwo.select_team_wins', {team: sample.home_label})}</span></strong>
        </div>
        {sample.allow_draw &&
          <div className="oneXtwo__nextBetTeaser__teamHolder oneXtwo__nextBetTeaser__teamHolder--draw">
            <div />
            <strong className=""><span>{I18n.t('onextwo.select_draw')}</span></strong>
          </div>}
        <div className="oneXtwo__nextBetTeaser__teamHolder oneXtwo__nextBetTeaser__teamHolder--away">
          <div><img src={sample.away_flag} /></div>
          <strong><span>{I18n.t('onextwo.select_team_wins', {team: sample.away_label})}</span></strong>
        </div>
      </div>
    </a>
  </div>
}

export default NextBetTeaser
